console.log('[editor-cta] loaded');

(function () {
  function setCtaVisible(wrapper, link, visible) {
    if (!wrapper || !link) return;

    if (visible) {
      wrapper.style.display = '';
      link.removeAttribute('aria-disabled');
      link.classList.remove('is-disabled');
    } else {
      // Opción recomendada: ocultar completamente
      wrapper.style.display = 'none';

      // Seguridad extra: evita que quede un href anterior clicable
      link.removeAttribute('href');
      link.setAttribute('aria-disabled', 'true');
      link.classList.add('is-disabled');
    }
  }


  function buildUrl(baseUrl, productId, templateId, shopifyVariantId) {
  if (!baseUrl || !productId || !templateId || !shopifyVariantId) return null;

  const hasQuery = baseUrl.includes('?');
  const sep = hasQuery ? '&' : '?';

  return `${baseUrl}${sep}productId=${encodeURIComponent(productId)}&editorType=advanced&templateId=${encodeURIComponent(templateId)}&shopifyVariantId=${encodeURIComponent(shopifyVariantId)}`;
}

  function updateCta(variantId) {
    const link = document.querySelector('a[data-editor-cta]');
    const wrapper = link ? link.closest('.editor-cta') : null;

    if (!link) {
      console.warn('[editor-cta] link not found');
      return;
    }
    if (!wrapper) {
      console.warn('[editor-cta] wrapper not found');
      return;
    }

    const baseUrl = wrapper.getAttribute('data-editor-base-url');
    const productId = wrapper.getAttribute('data-editor-product-id');

    // Si falta configuración base, ocultamos para evitar enlaces incorrectos
    if (!baseUrl || !productId) {
      console.warn('[editor-cta] missing data attrs', { baseUrl, productId });
      setCtaVisible(wrapper, link, false);
      return;
    }

    const variantsJsonEl = document.getElementById('editor-variants-json');
    if (!variantsJsonEl) {
      console.warn('[editor-cta] variants json not found');
      setCtaVisible(wrapper, link, false);
      return;
    }

    let variants;
    try {
      variants = JSON.parse(variantsJsonEl.textContent);
    } catch (e) {
      console.warn('[editor-cta] invalid variants json', e);
      setCtaVisible(wrapper, link, false);
      return;
    }

    const v = variants.find((x) => String(x.id) === String(variantId));
    const templateId = v && v.editor_templateid ? v.editor_templateid : null;

    // CLAVE: si la variante no tiene templateId, ocultamos el CTA
    if (!templateId) {
      console.warn('[editor-cta] missing templateId for variant', { variantId, v });
      setCtaVisible(wrapper, link, false);
      return;
    }

    
    const url = buildUrl(baseUrl, productId, templateId, variantId);
    if (!url) {
      setCtaVisible(wrapper, link, false);
      return;
    }

    link.setAttribute('href', url);
    setCtaVisible(wrapper, link, true);
  }

  function getCurrentVariantId() {
    const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input ? input.value : null;
  }

  document.addEventListener('DOMContentLoaded', function () {
    const current = getCurrentVariantId();
    if (current) updateCta(current);
  });

  document.addEventListener('variant:change', function (event) {
    const variant = event.detail && event.detail.variant;
    if (variant && variant.id) updateCta(variant.id);
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') {
      updateCta(e.target.value);
    }
  });
})();